import React from 'react';

export const Loader = (): React.ReactElement => {
    return (
        <div className='container mx-auto w-full h-screen flex items-center justify-center'>
            <div className='container mx-auto flex items-center justify-center mt-10'>
                <p className='text-4xl'>Loading...</p>
            </div>
        </div>
    );
};
